import { Config, makeFetcher } from '@/utils/fetch';
import { config } from '@/config';
import { INMSurveysData, INMSurveyUrl } from '@/types/types';

const makeNMDashboardService = (apiUrl: string) => {
    const fetcher = makeFetcher(apiUrl);

    return {
        getSurveysData: async (token: string, config?: Config) => {
            const res = await fetcher.get(`/${token}`, config);
            const data = (await res.json()) as Promise<INMSurveysData>;
            return data;
        },

        getSurveyUrl: async (surveyDisplayedId: string, targetToken: string) => {
            const res = await fetcher.get(`/${surveyDisplayedId}/${targetToken}`);
            const { surveyUrl } = (await res.json()) as INMSurveyUrl;
            return surveyUrl;
        },
    };
};

export const nmDashboardService = makeNMDashboardService(config.api.url.nmDashboard);
